module.exports = __webpack_public_path__ + "media/images/icons/credit_card/discover-82d10946b46c7e24938d67a0d3c5a291.png";